module.exports = __webpack_public_path__ + "static/media/excel.ff0dcfd3.svg";